<footer class="footer-area">
    <div class="container">
        <div class="subscribe-area">
            <div class="row align-items-center">
                <div class="col-lg-5 col-md-12">
                    <h2>Suscríbete a nuestro boletín</h2>
                </div>

                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="text" class="input-newsletter" placeholder="Ingresa tu correo electrónico" name="EMAIL">
                        <button type="submit">Suscribirme <i class="flaticon-plane"></i></button>
                    </form>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- LOGO Y DESCRIPCIÓN -->
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo">
                        <img src="assets/img/logo-original-funda.jpeg" alt="logo">
                    </a>
                    <p>
                        La Fundación Acosta Ñu trabaja con compromiso y solidaridad para apoyar a niños y familias,
                        promoviendo esperanza, bienestar y oportunidades para un futuro mejor.
                    </p>
                    <ul class="social-link">
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li>
                    </ul>
                </div>
            </div>

            <!-- ENLACES -->
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Enlaces rápidos</h3>
                    <ul class="footer-quick-links">
                        <li><a routerLink="/">Inicio</a></li>
                        <li><a routerLink="/about-one">Nosotros</a></li>
                        <li><a routerLink="/doctors">Equipo</a></li>
                        <li><a routerLink="/faq">Preguntas frecuentes</a></li>
                        <li><a routerLink="/prevention">Actividades</a></li>
                    </ul>
                </div>
            </div>

            <!-- CONTACTO -->
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contacto</h3>
                    <ul class="footer-contact-info">
                        <li><span>Dirección:</span> Manduvirá Nº 479 casi 14 de Mayo, Asunción</li>
                        <li><span>Email:</span> <a href="mailto:acostanufundacion@gmail.com">acostanufundacion@gmail.com</a></li>
                        <li><span>Teléfono:</span> <a href="tel:+595971372209">+595 971 372209</a></li>
                    </ul>
                </div>
            </div>

            <!-- HORARIOS -->
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Horario de atención</h3>
                    <ul class="footer-working-days">
                        <li><span>Lunes:</span> 08:00 - 18:00</li>
                        <li><span>Martes:</span> 08:00 - 18:00</li>
                        <li><span>Miércoles:</span> 08:00 - 18:00</li>
                        <li><span>Jueves - Viernes:</span> 08:00 - 18:00</li>
                        <li><span>Sábado:</span> 08:00 - 12:00</li>
                        <li><span>Domingo:</span> Cerrado</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- COPYRIGHT -->
    <div class="footer-bottom-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>
                        Copyright <i class='bx bx-copyright'></i> 2026 Fundación Acosta Ñu.
                        Diseñado por <a target="_blank" href="https://gmagenciaweb.com/">GM Agencia Web</a>
                    </p>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a href="#">Política de privacidad</a></li>
                        <li><a href="#">Términos y condiciones</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- DECORACIÓN -->
    <!--div class="footer-shape1"><img src="assets/img/footer-shape1.png" alt="image"></div>
    <div class="footer-shape2"><img src="assets/img/footer-shape2.png" alt="image"></div>
    <div class="footer-shape3"><img src="assets/img/footer-shape3.png" alt="image"></div-->
</footer>

<!-- BUSCADOR -->
<div class="search-overlay">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            <div class="search-overlay-layer"></div>
            
            <div class="search-overlay-close">
                <span class="search-overlay-close-line"></span>
                <span class="search-overlay-close-line"></span>
            </div>

            <div class="search-overlay-form">
                <form>
                    <input type="text" class="input-search" placeholder="Buscar aquí...">
                    <button type="submit"><i class='bx bx-search-alt'></i></button>
                </form>
            </div>
        </div>
    </div>
</div>

<app-live-data></app-live-data>

<div class="go-top"><i class='bx bx-up-arrow-alt'></i></div>